export const USER_SET_LOADING = 'USER_SET_LOADING';
export const USER_SET_USER = 'USER_SET_USER';
export const USER_SET_LOGOUT = 'USER_SET_LOGOUT';

const setUserLoading = (isLoading) => ({
    type: USER_SET_LOADING,
    payload: isLoading,
  });

export const setUser = (user) => {
    return async (dispatch, getState) => {
      dispatch(setUserLoading(true));
      try {
        dispatch({
            type: USER_SET_USER,
            payload: user,
        })
      } catch (error) {
          console.log('setUser error: ', error)
      } finally {
        dispatch(setUserLoading(false));
      }
    };
  };

  export const logOut = () => {
    return async (dispatch, getState) => {
      dispatch(setUserLoading(true));
      try {
        dispatch({
            type: USER_SET_LOGOUT,
            payload: null,
        })
      } catch (error) {
          console.log('setUser error: ', error)
      } finally {
        dispatch(setUserLoading(false));
      }
    };
  };